import React from 'react';
import { ReelMaker as ReelMakerList, ReelEditor as ReelEditorScreen } from 'components/ReelMaker';

/** Beam on Screen → Reel Maker list (`/#/beamonscreen/reel-maker`). */
export const ReelMaker: React.FC = () => <ReelMakerList title="Reel Maker" />;

/** Beam on Screen → Reel Maker canvas editor (`/#/beamonscreen/reel-maker/:reelId`). */
export const ReelEditor: React.FC = () => <ReelEditorScreen listTitle="Reel Maker" />;
